import { Routes, Route, useParams } from "react-router-dom";
import ProjectViewer from "./pages/ProjectViewer";
import ProjectsListPage from "./pages/ProjectsListPage";
import ProjectsIndexPage from "./pages/ProjectsIndexPage";
import WelcomePage from "./pages/WelcomePage";
import HowToAddProjects from "./pages/HowToAddProjects";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import { ProjectProvider } from "./contexts/ProjectContext";
import { useCountry } from "./contexts/CountryContext";

// Wrapper component to provide project context with slug from URL
function ProjectViewerWrapper() {
  const { slug } = useParams();

  // If no slug, show error message
  if (!slug) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Proyecto no encontrado
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Por favor, especifica un proyecto válido en la URL.
          </p>
          <a
            href="/"
            className="inline-block px-6 py-3 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors"
          >
            Volver al inicio
          </a>
        </div>
      </div>
    );
  }

  return (
    <ProjectProvider slug={slug}>
      <ProjectViewer />
    </ProjectProvider>
  );
}

// Home page wrapper - shows projects list for the country from subdomain
function HomePage() {
  const { country, isGlobal, loading } = useCountry();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Cargando...</p>
        </div>
      </div>
    );
  }

  // If country is detected from subdomain, show projects list
  if (country && !isGlobal) {
    return <ProjectsListPage />;
  }

  // If no country (global domain), show message or redirect to country selector
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center p-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Bienvenido a LotesPro
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Por favor, accede desde el subdominio de tu país (ej: peru.lotespro.com)
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          O en desarrollo: localhost:3001?country=PE
        </p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Routes>
      {/* Root path - shows projects list based on subdomain */}
      <Route path="/" element={<HomePage />} />

      {/* Project detail routes */}
      <Route path="/proyectos/:slug" element={<ProjectViewerWrapper />} />
      <Route path="/proyecto/:slug" element={<ProjectViewerWrapper />} />

      {/* Other static pages */}
      <Route path="/inicio" element={<WelcomePage />} />
      <Route path="/sobre-este-sitio" element={<AboutPage />} />
      <Route path="/como-agregar-proyectos" element={<HowToAddProjects />} />
      <Route path="/contacto" element={<ContactPage />} />
      <Route path="/proyectos" element={<ProjectsIndexPage />} />
    </Routes>
  );
}

export default App;
